export default __webpack_public_path__ + "static/noissue101-background-bottom-daf853434389e8e5d07bf683584d5aac.svg";